import { render, staticRenderFns } from "./GioiThieuForm.vue?vue&type=template&id=7db5ac00&scoped=true"
import script from "./GioiThieuForm.vue?vue&type=script&lang=js"
export * from "./GioiThieuForm.vue?vue&type=script&lang=js"
import style0 from "./GioiThieuForm.vue?vue&type=style&index=0&id=7db5ac00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db5ac00",
  null
  
)

export default component.exports